import css from 'styled-jsx/css';
import { colorPalette, pageWidth, sansSerif } from 'styles/css-constants';
import { MQ_LARGE, MQ_MEDIUM, MQ_MIDLARGE, MQ_SMALL_ONLY } from 'constants/mq';

/*
Overview
--------
twoGrid is roughly based off of surroundSound. Right now it 
is a layout specific to Cubby
*/
export default css`
  .Spread__title {
    margin-right: 0;
    margin-left: 0;
    justify-content: center;
  }

  .Spread__title h4 {
    font-family: ${sansSerif};
    font-size: var(--fontScale7);
    font-weight: normal;
    letter-spacing: normal;
    text-align: center;
    text-transform: lowercase;
  }

  :global(.ContentBundle--spread-twoGrid:nth-child(4n + 2)) .Spread__title {
    border-color: ${colorPalette.yellow};
  }

  :global(.ContentBundle--spread-twoGrid:nth-child(4n + 3)) .Spread__title {
    border-color: ${colorPalette.orangeAccent};
  }

  :global(.ContentBundle--spread-twoGrid:nth-child(4n + 4)) .Spread__title {
    border-color: ${colorPalette.greenAccent};
  }

  @media screen and ${MQ_SMALL_ONLY} {
    .Spread--twoGrid {
      padding-right: 1rem;
      padding-left: 1rem;
    }

    .Spread__item {
      margin-bottom: 2.25rem;
    }

    .Spread__item--ad {
      padding: 0 0.5rem;
    }
  }

  @supports (display: grid) {
    @media screen and ${MQ_MEDIUM} {
      .Spread--twoGrid {
        padding-right: 1.5rem;
        padding-left: 1.5rem;
      }

      .Spread__item {
        margin-bottom: 0;
      }

      .Spread__item--ad {
        grid-column: span 4;
      }

      .Spread__item--teaser {
        max-width: none;
        padding: 0;
      }

      .Spread__item--teaser:nth-child(2n + 1) {
        grid-column-start: 1;
      }

      .Spread__items {
        display: grid;
        grid-column-gap: 1.5rem;
        grid-row-gap: 1.5rem;
        grid-template-columns: repeat(2, 1fr);
        padding: 0;
      }
    }

    @media screen and ${MQ_LARGE} {
      .Spread--twoGrid {
        padding-right: 0;
        padding-left: 0;
      }

      .Spread__item--teaser:nth-child(2n + 1) {
        grid-column-start: 2;
      }

      .Spread__items {
        margin: 0;
        display: grid;
        grid-row-gap: 2.25rem;
        grid-template-columns:
          1fr repeat(2, calc((${pageWidth.large} - 24px) / 2))
          1fr;
        width: 100%;
        padding: 0;
      }

      .Spread__title h4 {
        font-size: var(--fontScale5);
      }
    }

    @media screen and ${MQ_MIDLARGE} {
      .Spread__items {
        grid-template-columns:
          1fr repeat(2, calc((${pageWidth.midlarge} - 24px) / 2))
          1fr;
      }
    }
  }

  /* CLEANUP Special divider for Cubby */
  :global(.cb) .Spread--twoGrid {
    padding-bottom: 1rem;
    grid-template:
      'title'
      'description'
      'items'
      'divider'
      / 1fr;
  }

  :global(.cb) .Spread--twoGrid::after {
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 92 26'%3E%3Ccircle cx='13' cy='13' r='13' fill='%23f15d29'/%3E%3Cpath fill='%23fbcb11' d='M33 0h26v26H33z'/%3E%3Cpath d='M66 0h26v26L66 0z' fill='%23bca3bf'/%3E%3C/svg%3E");
    grid-area: divider;
    justify-self: center;
    height: 19.5px;
    width: 69px;
  }

  @media screen and ${MQ_MEDIUM} {
    :global(.cb) .Spread--twoGrid::after {
      margin-top: 3rem;
    }
  }

  @media screen and ${MQ_LARGE} {
    :global(.cb) .Spread--twoGrid {
      grid-template:
        '....... title       .......'
        '.....   description .......'
        'items   items       items'
        'divider divider     divider'
        / 1fr 976px 1fr;
    }

    :global(.cb) .Spread--twoGrid::after {
      height: 26px;
      width: 92px;
    }
  }

  @media screen and ${MQ_MIDLARGE} {
    :global(.cb) .Spread--twoGrid {
      grid-template-columns: 1fr 1148px 1fr;
    }
  }
`;
